module.exports = __webpack_public_path__ + "img/default3.e79c3630.jpg";